import React, { useEffect, useState } from "react";
import "../../../assets/css/accountmetrics.scss";
import Loader from "../../../reusableComponents/Loader";
import { ReactComponent as Program } from "../../../assets/icons/program.svg";
import { ReactComponent as AccountInsights } from "../../../assets/icons/accountInsights.svg";
import { ReactComponent as TradingHistory } from "../../../assets/icons/tradingHistory.svg";
import { ReactComponent as AccountAnalysis } from "../../../assets/icons/accountAnalysis.svg";
import PublicShareDashboard from "./PublicShareDashboard";
import { useNavigate, useParams } from "react-router";
import {
  fetchAccountDetails,
  fetchAccountInsights,
  fetchAccountMetrics,
  fetchAccountObjectives,
  fetchMetricsTabs,
  fetchPerformanceChart,
} from "../../../utilities/PublicShare";
import AdvancedInsightsShare from "./AccountInsightsShare";
import TradingHistoryShare from "./TradingHistoryShare";
import AccountAnalysisShare from "./AccountAnalysis";
import MobileTabs from "../../../reusableComponents/MobileTabs/MobileTabs";
import html2canvas from "html2canvas";
import CombinedPopup from "../../Popups/CombinedPopup";
const AccountMetricPublicShare = () => {
  const navigate = useNavigate();
  const { platform, accountId } = useParams();

  const tabItems = [
    { name: "Program Objectives", value: 5, icon: <Program /> },
    { name: "Advanced Insights", value: 6, icon: <AccountInsights /> },
    { name: "Trading History", value: 7, icon: <TradingHistory /> },
    { name: "Account Analysis", value: 8, icon: <AccountAnalysis /> },
  ];

  const [permissionTabs, setPermissionTabs] = useState([]);
  const [mainTabination, setMainTabination] = useState(
    permissionTabs && permissionTabs[0]?.value
  );
  const [loading, setIsloading] = useState(false);
  const [isLoading, setIsloadings] = useState(null);

  const getMetricsTabs = async () => {
    setIsloadings(true);
    try {
      const response = await fetchMetricsTabs(accountId);
      if (response?.success && Array.isArray(response.data)) {
        const updatedTabs = response.data.map((items) => {
          const matchingTab = tabItems.find((item) => item.value === items.id);
          return {
            name: items.title,
            value: items.id,
            icon: matchingTab ? matchingTab.icon : null, // Use null if no matching icon
          };
        })?.sort((a, b) => a?.value-b?.value);
        setMainTabination(updatedTabs[0]?.value);
        setPermissionTabs(updatedTabs);
      } else {
        console.error(
          "Invalid response format or unsuccessful request:",
          response
        );
      }
    } catch (error) {
      console.error("Error fetching metrics tabs:", error);
    } finally {
      setIsloadings(false);
    }
  };

  useEffect(() => {
    getMetricsTabs();
  }, [accountId]);

  const handleTabClick = (value) => {
    setMainTabination(value);
  };

  const [data, setData] = useState({
    performanceChart: null,
    accountMetrics: null,
    accountDetails: null,
    accountObjectives: null,
    accountInsights: null,
    success: null,
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsloading(true);
      try {
        const [performance, metrics, details, objectives, insights] =
          await Promise.all([
            mainTabination === 1
              ? fetchPerformanceChart(accountId?.replace("#","%23"), platform)
              : Promise.resolve(null),
            mainTabination === 1 || mainTabination === 2 || mainTabination === 3
              ? fetchAccountMetrics(accountId?.replace("#","%23"), platform)
              : Promise.resolve(null),
            mainTabination === 1
              ? fetchAccountDetails(accountId?.replace("#","%23"), platform)
              : Promise.resolve(null),
            mainTabination === 1
              ? fetchAccountObjectives(accountId?.replace("#","%23"), platform)
              : Promise.resolve(null),
            mainTabination === 2
              ? fetchAccountInsights(accountId?.replace("#","%23"), platform)
              : Promise.resolve(null),
          ]);
  
        const allSuccess =
          (performance ? performance.success : true) &&
          (metrics ? metrics.success : true) &&
          (details ? details.success : true) &&
          (objectives ? objectives.success : true) &&
          (insights ? insights.success : true);
  
        setData({
          performanceChart: performance?.success ? performance.data : null,
          accountMetrics: metrics?.success ? metrics.data : null,
          accountDetails: details?.success ? details.data : null,
          accountObjectives: objectives?.success ? objectives.data : null,
          accountInsights: insights?.success ? insights.data : null,
          success: allSuccess,
        });
  
        setIsloading(false);
  
        if (!allSuccess) {
          setError("Some data could not be loaded. Check the console for details.");
        }
      } catch (err) {
        console.error("Error during fetch:", err);
        setError("An error occurred while fetching data.");
        setIsloading(false);
      }
    };
  
    platform && accountId && fetchData();
  }, [accountId, platform, mainTabination]);
  

  const handleCapture = async () => {
    try {
      const elementsToExclude = [
        ...document.querySelectorAll(
          ".exclude, .intercom-lightweight-app, .weglot-container.wg-default"
        ),
      ];

      const elementsWithParents = elementsToExclude.map((element) => ({
        element,
        parent: element.parentNode,
        nextSibling: element.nextSibling,
      }));

      elementsToExclude.forEach((element) => {
        if (element) element.parentNode.removeChild(element);
      });

      const canvas = await html2canvas(document.body, { scale: 2 });

      elementsWithParents.forEach(({ element, parent, nextSibling }) => {
        if (nextSibling) {
          parent.insertBefore(element, nextSibling);
        } else {
          parent.appendChild(element);
        }
      });

      const image = canvas.toDataURL("image/png");

      const link = document.createElement("a");
      link.href = image;
      link.download = "screenshot.png";
      link.click();
    } catch (error) {
      console.error("Error capturing the screenshot:", error);
    }
  };

  return (
    <div
      className="AccountMetricsContainer publicSharePage PageContainer"
      style={{ position: "relative", padding: "30px" }}
    >
      {(loading|| isLoading) && <Loader open={loading||isLoading} />}

      <div className="topHeaderBox">
        <h1>
          Alpha<span> Capital</span>
        </h1>
        <div className="rightCornerSect exclude">
          <button onClick={() => navigate("/signup")}>Sign Up</button>
          <button onClick={handleCapture}>Share</button>
        </div>
      </div>

      <div className="accntMetricsHeader">
        <div className="newTabination">
          {permissionTabs.map((tab) => (
            <div
              key={tab.value}
              onClick={() => handleTabClick(tab.value)}
              className={`newTabination-item ${mainTabination === tab.value ? "active" : ""
                }`}
            >
              <div className="svg-con">{tab?.icon}</div>
              {tab.name}
            </div>
          ))}
        </div>
      </div>
      <div className="mobileTabOption public_share">
        <MobileTabs
          activeTab={mainTabination}
          setActiveTab={setMainTabination}
          tabItems={permissionTabs}
        />
      </div>

      <div className="tabContent">
        {mainTabination === 1 && (
          <PublicShareDashboard ProfitHistory={data?.accountMetrics?.profit_chart}data={data} loading={loading} />
        )}
        {mainTabination === 2 && (
          <AdvancedInsightsShare
            AdvStats={data?.accountInsights && data?.accountInsights}
            data={data?.accountMetrics?.calculated_data}
            TradeJournalNew={data?.accountMetrics}
            TradingHistory={data?.accountMetrics?.data}
          />
        )}
        {mainTabination === 3 && (
          <TradingHistoryShare TradingHistory={data?.accountMetrics?.data} add={false}/>
        )}
        {mainTabination === 4 && <AccountAnalysisShare />}
        {permissionTabs.length === 0 && !isLoading && (
          <CombinedPopup
            btn={true}
            type={"error"}
            trigger={true}
            setTrigger={"setShowPopup"}
            head={"Oh snap!"}
            subhead={
              "Access denied: You do not have permission to view this Metrics."
            }
          // onClick={() => navigate("https://app.alphacapitalgroup.uk/")}
          />
        )}
      </div>
    </div>
  );
};

export default AccountMetricPublicShare;
